/**
 * Deferred Olark chat loader — avoids blocking initial map paint.
 * Loads only when user opens Contact us.
 */

export const OLARK_SITE_ID = '6304-998-10-8324';

let loadStarted = false;
let pendingMobileVisibility = null;

export function olarkSnippetExists() {
  return !!window.olarkReactAdded;
}

function applyMobileVisibility(isMobile) {
  if (!olarkSnippetExists() || typeof window.olark !== 'function') {
    return;
  }
  if (isMobile) {
    window.olark('api.box.hide');
  }
  else {
    window.olark('api.box.show');
  }
}

/**
 * @param {boolean} isMobile
 */
export function updateOlarkMobileVisibility(isMobile) {
  pendingMobileVisibility = isMobile;
  applyMobileVisibility(isMobile);
}

function injectOlarkSnippet(siteId) {
  if (olarkSnippetExists()) {
    window.olark('api.box.show');
    if (pendingMobileVisibility !== null) {
      applyMobileVisibility(pendingMobileVisibility);
    }
    return;
  }
  if (loadStarted) {
    return;
  }
  loadStarted = true;

  if (!siteId) {
    throw new Error('Olark siteId is required.');
  }

  const script = document.createElement('script');
  script.setAttribute('id', 'olark-react-snippet');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('async', true);
  script.innerHTML = `
    ;(function(o,l,a,r,k,y){if(o.olark)return; r="script";y=l.createElement(r);r=l.getElementsByTagName(r)[0]; y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r); y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)}; y.extend=function(i,j){y("extend",i,j)}; y.identify=function(i){y("identify",k.i=i)}; y.configure=function(i,j){y("configure",i,j);k.c[i]=j}; k=y._={s:[],t:[+new Date],c:{},l:a}; })(window,document,"static.olark.com/jsclient/loader.js");
    olark.identify('${siteId}');
    window.olarkReactAdded = true;
  `;
  document.body.appendChild(script);

  window.olark('api.box.onShrink', () => {
    if (pendingMobileVisibility) {
      window.olark('api.box.hide');
    }
  });

  if (pendingMobileVisibility !== null) {
    applyMobileVisibility(pendingMobileVisibility);
  }
}

/**
 * Load Olark immediately (e.g. Contact us click).
 * @param {string} [siteId]
 */
export function loadOlark(siteId = OLARK_SITE_ID) {
  injectOlarkSnippet(siteId);
}

/**
 * Legacy compatibility export. Olark must load only from explicit chat open actions.
 */
export function scheduleOlarkIdleLoad() {
  return false;
}

/**
 * Open chat: load script if needed, then expand widget.
 * @param {Event} [e]
 */
export function openOlarkChat(e) {
  if (e) {
    e.preventDefault();
  }
  loadOlark();
  if (typeof window.olark === 'function') {
    window.olark('api.box.expand');
  }
}
